export default function now() {
	if (window.performance && typeof window.performance.now === 'function') {
		return window.performance.now();
	}

	return Date.now();
}
